/* eslint-disable */

<template>
  <div class="vx-col">
    <vx-card class="mb-base">
      <div class="flex gap-3">
        <vs-button class="font-bold flex" :color="tab == 1 ? 'primary' : 'grey'" type="filled" @click="tab = 1"
          >Industry Trends Report</vs-button
        >
        <vs-button class="font-bold flex" :color="tab == 2 ? 'primary' : 'grey'" type="filled" @click="tab = 2"
          >Acme LLC Audit Report</vs-button
        >
      </div>

      <div class="flex flex-col gap-y-6 mt-6" v-if="tab === 1">
        <span class="flex items-center gap-x-2">
          <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
          <h5 class="text-grey">56% of companies took 12 to 18 months to discover that they had been breached.</h5>
        </span>
        <span class="flex items-center gap-x-2">
          <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
          <h5 class="text-grey">
            The majority of compromised user accounts were a result of "credential stuffing" and other attacks against online 3rd-party SaaS
            platforms, often due to poor oversight of user de-provisioning.
          </h5>
        </span>
        <span class="flex items-center gap-x-2">
          <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
          <h5 class="text-grey">
            Unpatched external-facing hosts are compromised within minutes by automated attacks and are made part of a botnet.
          </h5>
        </span>
        <span class="flex items-center gap-x-2">
          <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
          <h5 class="text-grey">Effectiveness of email spam campaigns is decreasing over time</h5>
        </span>
      </div>

      <div class="flex flex-col mt-6" v-else>
        <h5 class="text-xl font-bold mb-3">Concerns:</h5>
        <div class="flex flex-col gap-y-6">
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">Lack of centralized authentication and second-factor authentication.</h5>
          </span>
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">Vulnerable versions of service dependencies were found.</h5>
          </span>
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">Internal servers are externally accessible</h5>
          </span>
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">Users are susceptible to phishing campaigns</h5>
          </span>
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">Inadequate backup procedures were identified</h5>
          </span>
        </div>

        <div class="flex flex-col mt-8">
          <h5 class="text-xl font-bold mb-3">Observations:</h5>
          <span class="flex items-center gap-x-2">
            <p class="text-2xl mb-1" style="line-height: 0.4">•</p>
            <h5 class="text-grey">VDI in use by Acme LLC employees</h5>
          </span>
        </div>
      </div>
    </vx-card>

    <div class="main-border rounded-lg grid">
      <span class="main-bottom-border grid grid-cols-3 text-lg font-semibold" style="width: 100%">
        <span class="items-center text-center bg-dark py-2 main-right-border" :style="{ borderTopLeftRadius: '0.6rem' }">Control</span>
        <span class="items-center text-center bg-dark py-2 main-right-border">
          Cost <span class="text-grey">({{ formattedTotalCost }} Total)</span>
        </span>
        <span class="items-center text-center bg-dark py-2" :style="{ borderTopRightRadius: '0.6rem' }">Type</span>
      </span>

      <div class="flex flex-col">
        <div class="grid grid-cols-3" v-for="(question, index) in questions" :key="question.id">
          <span class="flex px-2 pb-2 main-right-border" :style="{ paddingTop: index === 0 ? '0.5rem' : '0rem' }">
            <v-select
              :id="`control-${index}`"
              v-model="questions[index].control.value"
              :options="controls"
              class="w-full rounded"
              placeholder="Select control"
              @input="resetCorrect('control', index)"
            />
          </span>
          <span class="items-center text-center main-right-border px-2 pb-2" :style="{ paddingTop: index === 0 ? '0.5rem' : '0rem' }">
            <span :id="`cost-${index}`" class="flex rounded">
              <vs-input
                v-model="questions[index].cost.value"
                class="w-full"
                :maxlength="5"
                placeholder="Enter cost"
                :style="{
                  borderColor: questions[index].cost.correct ? '#1ecb5a' : questions[index].cost.correct === false ? '#c93738' : '#181d2a',
                }"
                @input="resetCorrect('cost', index)"
              />
            </span>
          </span>
          <span
            class="grid grid-cols-2 gap-2 items-center justify-center px-2 pb-2"
            :style="{ paddingTop: index === 0 ? '0.5rem' : '0rem' }"
          >
            <vs-button
              :id="`type-${index}-preventative`"
              class="flex h-fit justify-center main-border"
              :color="questions[index].type.value === 'Preventative' ? 'primary' : 'grey'"
              :style="{
                borderColor:
                  questions[index].type.correct && questions[index].type.value === 'Preventative'
                    ? '#1ecb5a'
                    : questions[index].type.correct === false && questions[index].type.value === 'Preventative'
                    ? '#c93738'
                    : '#181d2a',
              }"
              @click="
                () => {
                  questions[index].type.value = 'Preventative';
                  resetCorrect('type', index);
                }
              "
              >Preventative</vs-button
            >
            <vs-button
              :id="`type-${index}-detective`"
              class="flex h-fit justify-center main-border"
              :color="questions[index].type.value === 'Detective' ? 'primary' : 'grey'"
              :style="{
                borderColor:
                  questions[index].type.correct && questions[index].type.value === 'Detective'
                    ? '#1ecb5a'
                    : questions[index].type.correct === false && questions[index].type.value === 'Detective'
                    ? '#c93738'
                    : '#181d2a',
              }"
              @click="
                () => {
                  questions[index].type.value = 'Detective';
                  resetCorrect('type', index);
                }
              "
              >Detective</vs-button
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      tab: 1,

      controls: [
        'WAF',
        'User account reviews',
        'Internet firewall',
        'MFA',
        'Anti-spam filtering',
        'DLP',
        'Logging and log monitoring',
        'Security training',
        'Desktop anti-virus',
        'Server patching',
      ],

      controlTypes: ['Preventative', 'Detective'],

      questions: [
        {
          control: {
            value: null,
            answer: 'MFA',
            correct: null,
          },
          cost: {
            value: null,
            answer: 20000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Preventative',
            correct: null,
          },
        },
        {
          control: {
            value: null,
            answer: 'Security training',
            correct: null,
          },
          cost: {
            value: null,
            answer: 10000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Preventative',
            correct: null,
          },
        },
        {
          control: {
            value: null,
            answer: 'Anti-spam filtering',
            correct: null,
          },
          cost: {
            value: null,
            answer: 10000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Preventative',
            correct: null,
          },
        },
        {
          control: {
            value: null,
            answer: 'Internet firewall',
            correct: null,
          },
          cost: {
            value: null,
            answer: 10000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Preventative',
            correct: null,
          },
        },
        {
          control: {
            value: null,
            answer: 'WAF',
            correct: null,
          },
          cost: {
            value: null,
            answer: 10000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Preventative',
            correct: null,
          },
        },
        {
          control: {
            value: null,
            answer: 'Server patching',
            correct: null,
          },
          cost: {
            value: null,
            answer: 15000,
            correct: null,
          },
          type: {
            value: null,
            answer: 'Detective',
            correct: null,
          },
        },
      ],
    };
  },
  methods: {
    resetCorrect(type, index) {
      this.questions[index][type].correct = null;
      document.getElementById(`${type}-${index}`).style.border = '1px solid transparent';
    },
    markSimulation() {
      let totalScore = 0;

      this.questions.forEach((question, index) => {
        if (question.control.value === question.control.answer) {
          totalScore++;
          question.control.correct = true;
          document.getElementById(`control-${index}`).style.border = '1px solid #1ecb5a';
        } else if (question.control.value) {
          question.control.correct = false;
          document.getElementById(`control-${index}`).style.border = '1px solid #c93738';
        }

        if (parseFloat(question.cost.value) === question.cost.answer) {
          totalScore++;
          question.cost.correct = true;
          document.getElementById(`cost-${index}`).style.border = '1px solid #1ecb5a ';
        } else if (question.cost.value) {
          question.cost.correct = false;
          document.getElementById(`cost-${index}`).style.border = '1px solid #c93738 ';
        }

        if (question.type.value === question.type.answer) {
          totalScore++;
          question.type.correct = true;
        } else if (question.type.value) {
          question.type.correct = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  computed: {
    totalCost() {
      return this.questions.reduce((sum, question) => {
        const costValue = parseInt(question.cost.value) || 0;
        return sum + costValue;
      }, 0);
    },
    formattedTotalCost() {
      return `$${Number(this.totalCost).toLocaleString()}`;
    },
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
